// 261005 E3-P4b2 — nút "Phương án (tốn AI)" dùng chung ②④⑤③ (vỏ antd; logic ở optionsAction.ts).
import React from 'react';
import { Button, Tooltip } from 'antd';
import { OPTIONS_LABEL, OPTIONS_TOOLTIP } from './optionsAction';

interface Props {
  onClick?: () => void;
  /** Có lý do ⇒ nút tắt, Tooltip hiện lý do. */
  disabledReason?: string;
}

const OptionsButton: React.FC<Props> = ({ onClick, disabledReason }) => (
  <Tooltip title={disabledReason ?? OPTIONS_TOOLTIP}>
    <span><Button size="small" type="default" className="btn-options" disabled={!!disabledReason || !onClick} onClick={onClick}>{OPTIONS_LABEL}</Button></span>
  </Tooltip>
);

export default OptionsButton;
